import Report from "./components/Report"

let module = "reports"

export default [{ path: "reports", component: Report, meta: { module: module, permissions: ["report-access"] } }]
